import { createSelector } from "reselect";
import { getOldTeamPoints } from "../action/selectors";
import { RootState } from "../store";
import { getTeam } from "../userCampaign/selectors";

export const getTeamProgress = createSelector(getOldTeamPoints, getTeam, (oldTeamPoints, team) => {
	return (team?.points || 0) - oldTeamPoints;
})


export const getTeamNameRequesting = (state: RootState) => state.team.requesting || false;